{
  "INBOX_MGMT": {
    "HEADER": "Gautų laiškų aplankai",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Prijungti iš naujo",
      "FACEBOOK": "Ryšys su Facebook baigė galioti arba buvo atšauktas. Puslapiui siunčiamos žinutės nepasiekia šio aplanko, o atsakymai gali būti neišsiųsti. Asmuo, kuris valdo Facebook puslapį, turi spustelėti Prijungti iš naujo ir prisijungti prie Facebook.",
      "INSTAGRAM": "Ryšys su Instagram baigė galioti arba buvo atšauktas. Paskyrai siunčiamos žinutės nepasiekia šio aplanko, o atsakymai gali būti neišsiųsti. Spustelėkite Prijungti iš naujo ir prisijunkite prie tos pačios Instagram paskyros. Kita paskyra sukuria naują aplanką.",
      "GOOGLE": "Ryšys su Google baigė galioti arba buvo atšauktas. Nauji el. laiškai nepasiekia šio aplanko, o atsakymai gali būti neišsiųsti. Spustelėkite Prijungti iš naujo ir prisijunkite prie Google kaip {email}.",
      "MICROSOFT": "Ryšys su Microsoft baigė galioti arba buvo atšauktas. Nauji el. laiškai nepasiekia šio aplanko, o atsakymai gali būti neišsiųsti. Spustelėkite Prijungti iš naujo ir prisijunkite prie Microsoft kaip {email}.",
      "ALLEGRO": "Ryšys su Allegro baigė galioti arba buvo atšauktas. Pirkėjų žinutės nepasiekia šio aplanko, o atsakymai gali būti neišsiųsti. Spustelėkite Prijungti iš naujo ir prisijunkite prie Allegro kaip pardavėjas {seller}. Kita pardavėjo paskyra sukuria naują aplanką.",
      "IMAP_LOGIN": "Pašto serveris atmeta IMAP prisijungimą {login}. Nauji laiškai šios dėžutės nepasiekia. Patikrinkite IMAP prisijungimo vardą ir slaptažodį skirtuke {tab} ir juos išsaugokite. Toliau bandome prisijungti, o dėžutė atsigaus, vos tik prisijungimas pavyks.",
      "WHATSAPP": "Ryšys su WhatsApp baigė galioti arba buvo atšauktas. Klientų priedai nepasiekia šios pašto dėžutės, o atsakymai gali nepavykti. Spustelėkite Prijungti iš naujo, prisijunkite prie Facebook ir vėl pasirinkite numerį {phone}."
    },
    "LIST": {
      "404": "Prie šios paskyros nėra pridėtų gautųjų laiškų aplankų.",
      "RECONNECT_REQUIRED": "Reikia prisijungti iš naujo"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Pasirinkti Kanalą",
        "BODY": "Pasirinkite paslaugų teikėją, kurį norite integruoti su pokalbių sistema."
      },
      "INBOX": {
        "TITLE": "Sukurti Gautų Laiškų Aplanką",
        "BODY": "Autentifikuokite savo paskyrą ir susikurkite gautų laiškų aplanką."
      },
      "AGENT": {
        "TITLE": "Pridėti Agentus",
        "BODY": "Pridėti agentus pire gautų laiškų oplanko."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Esate pasiruošę pradėti!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
        "PLACEHOLDER": "Įveskite savo gautų laiškų aplanko pavadinimą (pvz.: Acme Inc)",
        "ERROR": "Prašome įrašyti teisingą gautų laiškų aplanko pavadinimą"
      },
      "WEBSITE_NAME": {
        "LABEL": "Intenetinio Puslapio pavadinimas",
        "PLACEHOLDER": "Įveskite savo internetinio puslapio pavadinimą (pvz.: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Vidinis pavadinimas",
        "PLACEHOLDER": "Pavadinkite gautų laiškų aplanką taip, kaip jis rodomas šiame valdymo skydelyje",
        "ERROR": "Įveskite unikalų vidinį pavadinimą"
      },
      "FB": {
        "HELP": "PS: Po autorizacijos turėsime prieigą tik prie jūsų pranešimų puslapyje. Jūsų asmeninių pranešimų mes niekada negalėsime pasiekti.",
        "CHOOSE_PAGE": "Pasirinkti Puslapį",
        "CHOOSE_PLACEHOLDER": "Psirinkti puslapį iš sąrašo",
        "INBOX_NAME": "Gautų Laiškų Aplanko Pavadinimas",
        "ADD_NAME": "Prašome įrašyti gautų laiškų aplanko pavadinimą",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pasirinkti reikšmę",
        "CREATE_INBOX": "Sukurti gautų laiškų aplanką"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Tęsti su Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Prijunkite savo Instagram profilį",
        "HELP": "Norėdami pridėti savo Instagram profilį kaip kanalą, turite autentifikuoti savo Instagram profilį spustelėdami „Tęsti su Instagram“ ",
        "ERROR_MESSAGE": "Prisijungiant prie Instagram įvyko klaida, bandykite dar kartą",
        "ERROR_AUTH": "Prisijungiant prie Instagram įvyko klaida, bandykite dar kartą",
        "NEW_INBOX_SUGGESTION": "Ši Instagram paskyra anksčiau buvo susieta su kitu gautų laiškų aplanku ir dabar buvo perkelta čia. Visi nauji pranešimai bus rodomi čia. Senasis gautų laiškų aplankas nebegalės siųsti ar gauti šios paskyros pranešimų.",
        "DUPLICATE_INBOX_BANNER": "Ši Instagram paskyra buvo perkelta į naują Instagram kanalo gautų laiškų aplanką. Šiame gautų laiškų aplanke nebegalėsite siųsti / gauti Instagram pranešimų."
      },
      "TWITTER": {
        "HELP": "Norėdami pridėti savo Twitter profilį kaip kanalą, turite patvirtinti savo Twitter profilį spustelėdami „Prisijungti naudojant Twitter“ ",
        "ERROR_MESSAGE": "Prisijungiant prie Twitter įvyko klaida. Bandykite dar kartą",
        "TWEETS": {
          "ENABLE": "Kurkite pokalbius iš minėtų tweetų"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Interneto svetainės kanalas",
        "DESC": "Sukurkite kanalą savo svetainei ir pradėkite palaikyti savo klientus naudodami mūsų svetainės valdiklį.",
        "LOADING_MESSAGE": "Intenetinio puslapio palaikymo kanalo kūrimas",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanalo Avataras"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Prašome įvesti tesingą URL adresą"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Internetinio svetainės domenas",
          "PLACEHOLDER": "Įveskite savo internetinės svetainės pavadinimą (pvz.: Acme Inc)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Pasisveikinimo antraštė",
          "PLACEHOLDER": "Sveiki!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Pasisveikinimo tekstas",
          "PLACEHOLDER": "Su mumis susisiekti yra paprasta. Klauskite mūsų bet ko arba pasidalykite savo atsiliepimais."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanalo pasisveikinimo pranešimas",
          "PLACEHOLDER": "Acme Inc paprastai atsako per kelias valandas."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Leisti kanalo pasisveikinimą",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Leisti",
          "DISABLED": "Išjungta"
        },
        "REPLY_TIME": {
          "TITLE": "Nustatyti Atsakymo laiką",
          "IN_A_FEW_MINUTES": "Per kelias minutes",
          "IN_A_FEW_HOURS": "Per kelias minutes",
          "IN_A_DAY": "Per dieną",
          "HELP_TEXT": "Šis atsakymo laikas bus rodomas tiesioginio pokalbio valdiklyje"
        },
        "WIDGET_COLOR": {
          "LABEL": "Valdiklio Spalva",
          "PLACEHOLDER": "Atnaujinkite valdiklyje naudojamą valdiklio spalvą"
        },
        "SUBMIT_BUTTON": "Sukurti Gautų Laiškų Aplanką",
        "API": {
          "ERROR_MESSAGE": "Nepavyko sukurti svetainės kanalo, bandykite dar kartą"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/Whatsapp Kanalas",
        "DESC": "Integruokite Twilio ir pradėkite komunikuoti su savo klientais SMS ar WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Paskyros SID",
          "PLACEHOLDER": "Įveskite Twilio paskyros SID",
          "ERROR": "Šis laukas yra privalomas"
        },
        "API_KEY": {
          "USE_API_KEY": "Naudokite API Key autentifikavimą",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Įveskite savo API Key SID",
          "ERROR": "Šis laukas yra privalomas"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Įveskite savo API Key Secret",
          "ERROR": "Šis laukas yra privalomas"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Pranešimų siuntimo paslaugos SID",
          "PLACEHOLDER": "Įveskite jūsų Twilio pranešimų siuntimo paslaugos SID",
          "ERROR": "Šis laukas yra privalomas",
          "USE_MESSAGING_SERVICE": "Naudokite Twilio pranešimų siuntimo paslaugą"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanalo tipas",
          "ERROR": "Pasirinkite savo Kanalo Tipą"
        },
        "AUTH_TOKEN": {
          "LABEL": "Prieigos Raktas",
          "PLACEHOLDER": "Įveskite Twilio paskyros prieigos raktą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "CHANNEL_NAME": {
          "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti gautų laiškų aplanko pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefono numeris",
          "PLACEHOLDER": "Įveskite telefono numerį iš kurio bus siunčiamas pranešimas.",
          "ERROR": "Pateikite galiojantį telefono numerį, kuris prasideda „+“ ženklu ir kuriame nėra tarpų."
        },
        "API_CALLBACK": {
          "TITLE": "Automatinio atskambinimo URL",
          "SUBTITLE": "Turite sukonfigūruoti pranešimo atgalinio skambinimo URL Twilio su čia nurodytu URL."
        },
        "SUBMIT_BUTTON": "Sukurti Twilio kanalą",
        "API": {
          "ERROR_MESSAGE": "Nepavyko autentifikuoti Twilio, bandykite dar kartą"
        }
      },
      "SMS": {
        "TITLE": "SMS kanalas",
        "DESC": "Pradėkite palaikyti savo klientus naudodami SMS.",
        "PROVIDERS": {
          "LABEL": "API tiekėjas",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Pralaidumas",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti SMS kanalo"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Paskyros ID",
            "PLACEHOLDER": "Įveskite savo Bandwith Paskyros ID",
            "ERROR": "Šis laukas yra privalomas"
          },
          "API_KEY": {
            "LABEL": "API raktas",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Šis laukas yra privalomas"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Šis laukas yra privalomas"
          },
          "APPLICATION_ID": {
            "LABEL": "Programos ID",
            "PLACEHOLDER": "Įveskite savo Bandwith Programos ID",
            "ERROR": "Šis laukas yra privalomas"
          },
          "INBOX_NAME": {
            "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
            "PLACEHOLDER": "Prašome įrašyti gautų laiškų aplanko pavadinimą",
            "ERROR": "Šis laukas yra privalomas"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefono numeris",
            "PLACEHOLDER": "Įveskite telefono numerį iš kurio bus siunčiamas pranešimas.",
            "ERROR": "Pateikite galiojantį telefono numerį, kuris prasideda „+“ ženklu ir kuriame nėra tarpų."
          },
          "SUBMIT_BUTTON": "Sukurti Bandwidth Kanalą",
          "API": {
            "ERROR_MESSAGE": "Nepavyko autentifikuoti Bandwidth, bandykite dar kartą"
          },
          "API_CALLBACK": {
            "TITLE": "Automatinio atskambinimo URL",
            "SUBTITLE": "Turite sukonfigūruoti pranešimo atgalinio skambinimo URL Bandwidth su čia nurodytu URL."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
            "PLACEHOLDER": "Prašome įrašyti gautų laiškų aplanko pavadinimą",
            "ERROR": "Šis laukas yra privalomas"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefono numeris",
            "PLACEHOLDER": "Įveskite telefono numerį, iš kurio bus siunčiami pranešimai.",
            "ERROR": "Pateikite galiojantį telefono numerį, kuris prasideda ženklu `+`."
          },
          "SUBMIT_BUTTON": "Sukurti SMS Brana kanalą",
          "API": {
            "ERROR_MESSAGE": "Mes negalėjome sukurti SMS Brana kanalo"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
            "PLACEHOLDER": "Prašome įrašyti gautų laiškų aplanko pavadinimą",
            "ERROR": "Šis laukas yra privalomas"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefono numeris",
            "PLACEHOLDER": "Įveskite telefono numerį, iš kurio bus siunčiami pranešimai.",
            "ERROR": "Pateikite galiojantį telefono numerį, kuris prasideda ženklu `+`."
          },
          "SUBMIT_BUTTON": "Sukurti DIDWW kanalą",
          "API": {
            "ERROR_MESSAGE": "Mes negalėjome sukurti DIDWW kanalo"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API tiekėjas",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Turite sukonfigūruoti webhook URL ir patvirtinimo prieigos raktą Facebook portale, naudodami toliau nurodytas reikšmes.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Patikros Prieigos Raktas"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Greitas nustatymas su Meta",
          "DESC": "Būsite nukreipti į Meta, kad prisijungtumėte prie savo WhatsApp Business paskyros. Administratoriaus prieiga padės nustatymą atlikti sklandžiai ir lengvai.",
          "BENEFITS": {
            "EASY_SETUP": "Rankinio konfigūravimo nereikia",
            "SECURE_AUTH": "Saugi autentifikacija, pagrįsta OAuth",
            "AUTO_CONFIG": "Automatinis webhook ir telefono numerio sukonfigūravimas"
          },
          "SUBMIT_BUTTON": "Prisijungti su WhatsApp Business",
          "AUTH_PROCESSING": "Autentifikuojama su Meta",
          "WAITING_FOR_BUSINESS_INFO": "Užbaikite verslo nustatymą Meta lange...",
          "PROCESSING": "Nustatoma jūsų WhatsApp Business paskyra",
          "CANCELLED": "WhatsApp registracija atšaukta",
          "WAITING_FOR_AUTH": "Laukiama autentifikacijos...",
          "INVALID_BUSINESS_DATA": "Gauti neteisingi verslo duomenys iš Facebook. Bandykite dar kartą.",
          "SIGNUP_ERROR": "Įvyko registracijos klaida",
          "SDK_LOAD_ERROR": "Nepavyko įkelti Facebook SDK. Bandykite dar kartą.",
          "AUTH_NOT_COMPLETED": "Autentifikacija nebaigta. Pradėkite procesą iš naujo.",
          "SUCCESS_FALLBACK": "WhatsApp Business paskyra sėkmingai sukonfigūruota",
          "RECONNECTED": "WhatsApp kanalas sėkmingai prijungtas iš naujo"
        },
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti WhatsApp kanalo"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanalas",
        "DESC": "Integruokite API kanalą ir pradėkite komunikuoti su savo klientais.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalo Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti kanalo pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Sukurti API kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti API kanalo"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanalas",
        "DESC": "Integruokite Salesforce kanalą ir pradėkite aptarnauti savo klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalo Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti kanalo pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Sukonfigūruokite savo Salesforce diegimo pagrindinį URL.",
          "PLACEHOLDER": "Salesforce API URL"
        },
        "KEY_ID": {
          "LABEL": "Rakto ID",
          "SUBTITLE": "Jūsų Salesforce kanalo rakto ID.",
          "PLACEHOLDER": "RAKTO ID"
        },
        "SECRET": {
          "LABEL": "Paslaptis",
          "SUBTITLE": "Jūsų Salesforce kanalo paslaptis.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Sukurti Salesforce kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti Salesforce kanalo"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Salesforce sistemoje turite sukonfigūruoti webhook URL, naudodami čia nurodytą URL."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer prieigos raktas",
          "SUBTITLE": "Konfigūruodami webhook Salesforce sistemoje, naudokite šį bearer prieigos raktą autentifikacijai."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Perrašyti el. laiško siuntėją",
          "SUBTITLE": "Jei nustatyta, šis el. pašto adresas bus naudojamas kaip visų siunčiamų laiškų siuntėjas vietoj pokalbio šaltinio el. pašto.",
          "PLACEHOLDER": "pvz. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro kanalas",
        "DESC": "Prijunkite Allegro pardavėjo paskyrą ir atsakykite į jos žinučių centro žinutes iš Kontaktų centro.",
        "CHANNEL_NAME": {
          "LABEL": "Gautų Laiškų Aplanko Pavadinimas",
          "SUBTITLE": "Pavadinimas, kurį agentai mato šiam gautų laiškų aplankui.",
          "PLACEHOLDER": "Įveskite gautų laiškų aplanko pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "SUBMIT_BUTTON": "Prisijungti naudojant Allegro",
        "API": {
          "ERROR_MESSAGE": "Jungiantis prie Allegro įvyko klaida, bandykite dar kartą"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro prisijungimas",
          "SUBTITLE": "Pardavėjo paskyra, kurios žinutes šis gautų laiškų aplankas skaito ir į jas atsako."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland kanalas",
        "DESC": "Atsakykite į užklausų žinutes, kurias pirkėjai jums siunčia Kaufland prekyvietėje.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalo Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti kanalo pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32 simbolių Client Key iš jūsų Kaufland pardavėjo paskyros API nustatymų puslapio.",
          "PLACEHOLDER": "32 simbolių raktas",
          "ERROR": "Įveskite 32 simbolių Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64 simbolių Secret Key, priklausantis Client Key. Kaufland jį parodo vieną kartą ir niekada nesiunčia atgal į šį puslapį.",
          "PLACEHOLDER": "64 simbolių raktas",
          "ERROR": "Įveskite 64 simbolių Secret Key"
        },
        "SUBMIT_BUTTON": "Sukurti Kaufland Kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti Kaufland kanalo"
        },
        "DISCONNECTED": {
          "TITLE": "Atjungta",
          "MESSAGE": "Kaufland atmetė šiuos API raktus. Įveskite Client Key ir Secret Key dar kartą, kad iš naujo prijungtumėte šį gautų laiškų aplanką."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "El. pašto kanalas",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalo Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti kanalo pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "EMAIL": {
          "LABEL": "El. paštas",
          "SUBTITLE": "Email where your customers sends you support tickets",
          "PLACEHOLDER": "El. paštas"
        },
        "SUBMIT_BUTTON": "Sukurti El. pašto kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti el. pašto kanalo"
        },
        "FINISH_MESSAGE": "Pradėkite peradresuoti savo el. laiškus toliau nurodytu el. pašto adresu."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanalas",
        "DESC": "Integruokite LINE kanalą ir pradėkite komunikuoti su savo klientais.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalo Pavadinimas",
          "PLACEHOLDER": "Prašome įrašyti kanalo pavadinimą",
          "ERROR": "Šis laukas yra privalomas"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE kanalo ID",
          "PLACEHOLDER": "LINE kanalo ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanalo Secret",
          "PLACEHOLDER": "LINE Kanalo Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanalo Prieigos Raktas",
          "PLACEHOLDER": "LINE Kanalo Prieigos Raktas"
        },
        "SUBMIT_BUTTON": "Sukurti LINE kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti LINE kanalo"
        },
        "API_CALLBACK": {
          "TITLE": "Automatinio atskambinimo URL",
          "SUBTITLE": "Turite sukonfigūruoti LINE programoje Webhook URL, su čia nurodytu URL."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanalas",
        "DESC": "Integruokite Telegram kanalą ir pradėkite komunikuoti su savo klientais.",
        "BOT_TOKEN": {
          "LABEL": "Boto Prieigos Raktas",
          "SUBTITLE": "Sukonfigūruokite boto prieigos raktą, kurį gavote iš Telegram BotFather.",
          "PLACEHOLDER": "Boto Prieigos Raktas"
        },
        "SUBMIT_BUTTON": "Sukurti Telegram kanalą",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome išsaugoti telegram kanalo"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Skambučiai",
        "DESC": "Nustatykite, kokie skambučiai bus rodomi šiame gautų laiškų aplanke.",
        "NAME": {
          "LABEL": "Gautų laiškų aplanko pavadinimas",
          "SUBTITLE": "Pasirinkite lengvai atpažįstamą pavadinimą."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefono numeris",
          "SUBTITLE": "Įveskite telefono numerius, priklausančius šiam gautų laiškų aplankui, vėliau galėsite pridėti daugiau numerių.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Sukurti skambučių gautų laiškų aplanką",
        "API": {
          "ERROR_MESSAGE": "Mes negalėjome sukurti gautų laiškų aplanko"
        }
      },
      "AUTH": {
        "TITLE": "Pasirinkti Kanalą",
        "DESC": "Pokalbių sistema palaiko tiesioginio pokalbio valdiklius, Facebook Messenger, WhatsApp, el. laiškus ir kt. kaip kanalus. Jei norite sukurti personalizuotą kanalą, galite jį sukurti naudodami API kanalą. Norėdami pradėti, pasirinkite vieną iš toliau pateiktų kanalų."
      },
      "AGENTS": {
        "TITLE": "Agentai",
        "DESC": "Čia galite pridėti agentų, kad galėtumėte tvarkyti naujai sukurtus gautų laiškų aplanką. Tik šie pasirinkti agentai turės prieigą prie jūsų gautų laiškų aplanko. Agentai, kurie nėra šio dalis, prisijungę negalės matyti pranešimų arba atsakyti į juos. <br> <b>PS:</b> Jei jums reikia prieigos prie visų gautų laiškų aplankų, turėtumėte įtraukti save kaip agentą prie visų sukurtų aplankų, kaip administratorius.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pasirinkite agentus gautų laiškų aplankams"
      },
      "DETAILS": {
        "TITLE": "Gautų Laiškų Aplanko Detali Informacija",
        "DESC": "Žemiau esančiame meniu pasirinkite Facebook puslapį, kurį norite prijungti prie pokalbių sistemos. Taip pat galite priskirti norimą pavadinimą savo gautų laiškų aplankui, kad būtų lengviau atpažinti."
      },
      "FINISH": {
        "TITLE": "Atlikta!",
        "DESC": "Sėkmingai užbaigėte savo Facebook puslapio integravimą su pokalbių sistema. Kai kitą kartą klientas parašys pranešimą jūsų puslapyje, pokalbis automatiškai pasirodys jūsų gautų laiškų aplanke.<br>Taip pat pateikiame valdiklio scenarijų, kurį galite lengvai pridėti prie savo svetainės. Kai tai bus įdiegta jūsų svetainėje, klientai gali jums siųsti pranešimus tiesiai iš jūsų svetainės, nenaudodami jokio išorinio įrankio, o pokalbis bus rodomas čia, pokalbių sistemoje.<br>Puiku, ar ne? Na, mes tikrai stengiamės tokiais būti :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Pasirinkite el. pašto paslaugų teikėją",
        "DESCRIPTION": "Pasirinkite el. pašto paslaugų teikėją iš toliau pateikto sąrašo. Jei sąraše nematote savo el. pašto teikėjo, galite pasirinkti kitą teikėją ir pateikti IMAP/SMTP prisijungimo duomenis."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft El. paštas",
        "DESCRIPTION": "Spustelėkite mygtuką Prisijungti naudojant Microsoft, kad pradėtumėte. Būsite nukreipti į prisijungimo el. pašto pagalba puslapį. Kai sutiksite su prašomais leidimais, būsite nukreipti atgal į gautų laiškų aplanko kūrimo veiksmą.",
        "EMAIL_PLACEHOLDER": "Įvesti el. pašto adresą",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Prisijungiant prie Microsoft įvyko klaida, bandykite dar kartą"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Įvesti el. pašto adresą",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentifikuojamas jus naudojant Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Kažkas nepavyko, atnaujinkite puslapį...",
      "ERROR_FB_UNAUTHORIZED": "Jūs nesate įgalioti atlikti šį veiksmą. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Įsitikinkite, kad turite prieigą prie „Facebook“ puslapio su visapusiška kontrole. Daugiau apie „Facebook“ vaidmenis galite perskaityti <a href=\" https://www.facebook.com/help/187316341316631\">čia</a>.",
      "ERROR_CHANNEL_CREATION": "Nepavyko sukurti gautų laiškų aplanko. Bandykite dar kartą.",
      "CREATING_CHANNEL": "Kuriamas gautų laiškų aplankas...",
      "TITLE": "Konfigūruoti gautų laiškų aplanko informaciją",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Pridėti agentus",
      "ADD_AGENTS": "Pridedami agentai gautų laiškų aplankams..."
    },
    "FINISH": {
      "TITLE": "Jūsų Gautų Laiškų Aplankas yra paruoštas!",
      "MESSAGE": "Dabar galite bendrauti su klientais naudodami naująjį kanalą. Gero naudojimo",
      "BUTTON_TEXT": "Nuvesk mane ten",
      "MORE_SETTINGS": "Daugiau nustatymų",
      "WEBSITE_SUCCESS": "Sėkmingai baigėte kurti svetainės kanalą. Nukopijuokite toliau pateiktą kodą ir įdėkite jį į savo svetainę. Kai kitą kartą klientas naudosis tiesioginiu pokalbiu, pokalbis bus automatiškai rodomas jūsų gautų pranešimų aplanke."
    },
    "REAUTH": "Pakartotinai autorizuoti",
    "VIEW": "Paržiūra",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Gautų laiškų aplanko nustatymai atnaujinti sėkmingai",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatinis priskyrimas atnaujintas sėkmingai",
        "ERROR_MESSAGE": "Nepavyko atnaujinti gautų laiškų aplanko nustatymų. Pabandykite dar kartą vėliau."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Leisti",
        "DISABLED": "Išjungta"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Leisti",
        "DISABLED": "Išjungta"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Įjungta",
        "DISABLED": "Išjungta"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Siuntėjo vardas",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "Pvz:",
        "FRIENDLY": {
          "TITLE": "Draugiškas",
          "FROM": "nuo",
          "SUBTITLE": "Prie siuntėjo vardo pridėkite atsakymą išsiuntusio agento vardą, kad atsakymas būtų draugiškas."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionalas",
          "SUBTITLE": "Naudokite tik sukonfigūruotą įmonės pavadinimą kaip siuntėjo vardą el. pašto antraštėje."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Sukonfigūruokite įmonės pavadinimą",
          "PLACEHOLDER": "Įveskite įmonės pavadinimą",
          "SAVE_BUTTON_TEXT": "Išsaugoti"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Leisti",
        "DISABLED": "Išjungta"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Leisti",
        "DISABLED": "Išjungta"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Nėra"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Leisti",
        "DISABLED": "Išjungta"
      },
      "ENABLE_HMAC": {
        "LABEL": "Leisti"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Įjungta",
        "DISABLED": "Išjungta"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Įjungta",
        "DISABLED": "Išjungta"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Įjungti gaunamų el. laiškų sinchronizavimą"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Įjungti pasirinktinį el. pašto domeną (mokama paslauga)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Įjungti Facebook komentarų apdorojimą"
      },
      "SIGNATURE": {
        "TITLE": "HTML parašas",
        "SUB_TEXT": "Šis parašas bus pridėtas kiekvieno iš šio gautų laiškų aplanko siunčiamo pranešimo apačioje.",
        "HTML_CONTENT": "HTML kodas",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} bus pakeistas agento vardu.\n{'{{'}email{'}}'} bus pakeistas el. laišką išsiuntusio agento el. pašto adresu.\n{'{{'}position{'}}'} bus pakeistas agento pareigomis.\n{'{{'}custom_line{'}}'} bus pakeistas agento pasirinktine eilute.\n{'{{'}email_signature_picture{'}}'} bus pakeistas agento el. pašto parašo paveikslėlio URL adresu (ne img žyma) — naudokite jį kaip paveikslėlio šaltinį (img žymos src atributą).",
        "PREVIEW": "Peržiūra"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Parašai pagal šalį",
        "SUB_TEXT": "Atsakymas gauna pirkėjo šalies parašą.",
        "HELP": "Atsakymas pasirašomas pagal pokalbio šalį: pagal Kaufland parduotuvę, Allegro užsakymo prekyvietę, o jei jų nėra, pagal kalbą, kuria rašo pirkėjas. Kai šalis nežinoma arba jai čia nėra parašo, naudojamas aukščiau esantis HTML parašas. Prekyvietės draudžia nuorodas į jūsų svetainę ir kontaktinius duomenis, todėl palikite tik sveikinimą ir {'{{'}name{'}}'}.",
        "EMPTY": "Dar neturite šalių parašų, todėl atsakymuose naudojamas aukščiau esantis HTML parašas.",
        "COUNTRY": "Pasirinkite šalį",
        "ADD": "Pridėti šalies parašą",
        "REMOVE": "Pašalinti"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Telefono numerio skambinimo prefiksas",
        "PLACEHOLDER": "Įveskite prefiksą teisingam skambučio nukreipimui (pvz., *99)",
        "HELP_TEXT": "Šis prefiksas bus automatiškai pridedamas prieš kontakto telefono numerį skambinant iš šio gautų laiškų aplanko."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Mygtuko „išspręsime vėliau“ tekstas",
        "PLACEHOLDER": "pvz., Šią temą išspręsime el. paštu. Dabar noriu paklausti apie ką nors kita.",
        "HELP_TEXT": "Valdiklio mygtuko, kuriuo lankytojas palieka dabartinę temą ir paklausia apie ką nors kita, tekstas. Jei paliksite tuščią, bus naudojamas numatytasis tekstas lankytojo kalba."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Automatiškai atidėti praleistus skambučius X minučių",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatiškai atidėti praleistus skambučius nurodytam minučių skaičiui. Palikite tuščią arba įveskite 0, kad išjungtumėte."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Išspręsti praleistą skambutį po X nesėkmingų atgalinių skambučių",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Kai praleistas skambutis buvo perskambintas X kartų ir klientas neatsiliepė, jis automatiškai išsprendžiamas ir pridedama privati pastaba. Palikite tuščią arba įveskite 0, kad išjungtumėte."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Klausimų pasiūlymai",
        "SUB_TEXT": "Sukonfigūruokite iš anksto nustatytus klausimus, kuriuos klientai gali naudoti bendraudami su jūsų agentais.",
        "QUESTIONS_LABEL": "Klausimai",
        "ADD_QUESTION": "Pridėti klausimą",
        "REMOVE": "Pašalinti",
        "QUESTION_TEXT": "Tekstas, rodomas burbule.",
        "QUESTION_TEXT_PLACEHOLDER": "Privaloma",
        "QUESTION_PAYLOAD": "Tekstas, siunčiamas paspaudus.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Neprivaloma",
        "NO_BOT_MESSAGE": "Norėdami generuoti papildomus AI pasiūlymus, prijunkite botą.",
        "BOT_CONNECTED_MESSAGE": "AI klausimų pasiūlymus iš boto galima aktyvuoti jo",
        "BOT_SETTINGS_LINK": "nustatymuose"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatyvūs el. pašto adresai",
        "SUB_TEXT": "Papildomi adresai, kuriuos šis gautųjų aplankas turėtų laikyti savais gaudamas persiųstą paštą.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Pridėti",
        "REMOVE": "Pašalinti",
        "EMPTY": "Nesukonfigūruota jokių alternatyvių el. pašto adresų.",
        "HELP_TEXT": "Kai el. laiškas atkeliauja vienu iš šių adresų kaip gavėjas, atsakymai bus siunčiami tuo pačiu adresu kaip siuntėjas. Įsitikinkite, kad jūsų siunčiamasis SMTP serveris leidžia siųsti iš šių adresų.",
        "SIGNATURE_LABEL": "Parašas",
        "PRIMARY_SIGNATURE": "Pagrindinis (numatytasis)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Papildomi parašai",
        "SUB_TEXT": "Čia apibrėžkite papildomus parašus ir priskirkite juos toliau nurodytiems alternatyviems el. paštams.",
        "OPTION": "Parašas {number}",
        "ADD": "Pridėti parašą",
        "REMOVE": "Pašalinti",
        "HELP_TEXT": "Kai atsakymas siunčiamas iš alternatyvaus el. pašto, vietoj pašto dėžutės parašo naudojamas jam priskirtas parašas. Alternatyvūs el. paštai, palikti ties „Pagrindinis (numatytasis)“, naudoja pašto dėžutės parašą."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "AVATAR_DELETE_BUTTON_TEXT": "Ištrinti Avatarą",
      "DELETE_REQUESTED_TOOLTIP": "Šis gautų laiškų aplankas pažymėtas ištrynimui",
      "RESTORE_BUTTON_TEXT": "Atkurti",
      "CONFIRM": {
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Ar tikrai norite ištrinti ",
        "PLACE_HOLDER": "Įveskite {inboxName}, kad patvirtintumėte",
        "YES": "Taip, Trinti ",
        "NO": "Ne, Išsaugoti "
      },
      "API": {
        "SUCCESS_MESSAGE": "Gautų Laiškų Aplankas ištrintas sėkmingai",
        "MARKED_FOR_DELETION_MESSAGE": "Gautų laiškų aplankas pažymėtas ištrynimui",
        "RESTORE_SUCCESS_MESSAGE": "Gautų laiškų aplankas sėkmingai atkurtas",
        "ERROR_MESSAGE": "Nepavyko ištrinti gautų laiškų aplanko. Pabandykite dar kartą vėliau.",
        "RESTORE_ERROR_MESSAGE": "Nepavyko atkurti gautų laiškų aplanko. Pabandykite dar kartą vėliau.",
        "AVATAR_SUCCESS_MESSAGE": "Gautų Laiškų Aplanko avataras ištrintas sėkmingai",
        "AVATAR_ERROR_MESSAGE": "Nepavyko ištrinti gautų laiškų aplanko avataro. Pabandykite dar kartą vėliau."
      }
    },
    "TABS": {
      "SETTINGS": "Nustatymai",
      "COLLABORATORS": "Bendradarbiai",
      "AUTOMATIC_PRIORITY": "Automatinis prioritetas",
      "AUTOMATIC_LABELING": "Automatinis žymėjimas",
      "CONFIGURATION": "Konfiguracija",
      "CAMPAIGN": "Akcijos",
      "PRE_CHAT_FORM": "Anketa, rodoma prieš pokalbio internetu pradžią",
      "BUSINESS_HOURS": "Darbo valandos",
      "WIDGET_BUILDER": "Valdiklių kūrimo priemonė",
      "BOT_CONFIGURATION": "Boto konfiguracija",
      "SLA": "SLA"
    },
    "SETTINGS": "Nustatymai",
    "FEATURES": {
      "LABEL": "Funkcijos",
      "DISPLAY_FILE_PICKER": "Valdiklyje rodyti failų pasirinkimą",
      "DISPLAY_EMOJI_PICKER": "Valdiklyje rodyti emoji pasirinkimą",
      "ALLOW_END_CONVERSATION": "Leisti vartotojams baigti pokalbį naudojant valdiklį",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Rodyti mygtuką 'Pradėti naują pokalbį' valdiklio antraštėje",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Slėpti įvesties lauką, kai rodomas pradėti naują pokalbį mygtukas",
      "SHOW_HANDOFF_BUTTON": "Rodyti mygtuką 'Perduoti operatoriui' valdiklio antraštėje",
      "AUTO_CLOSE_OLD": "Išsprendus vieną skambutį, pažymėti visus ankstesnius skambučius iš to paties numerio kaip išspręstus",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatiškai priskirti praleistus skambučius atliekant išeinantį skambutį",
      "USE_INBOX_AVATAR_FOR_BOT": "Botui naudokite gautų laiškų aplanko pavadinimą ir avatarą",
      "ALLOW_OFFLINE_REPLY": "Leisti agentams siųsti pranešimus, kai kontaktas neprisijungęs ir el. pašto tęstinumas nepasiekiamas"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger scenarijus",
      "MESSENGER_SUB_HEAD": "Įdėkite šį mygtuką savo <body> žymos viduje",
      "INBOX_AGENTS": "Agentai",
      "INBOX_TEAMS": "Komandos",
      "INBOX_COOPERATORS": "Bendradarbiai",
      "SELECT_PLACEHOLDER": "Pasirinkti",
      "AGENTS_OR_TEAMS_INFO": "Galite priskirti arba agentus, arba komandas - ne abu vienu metu.",
      "INBOX_AGENTS_SUB_TEXT": "Pridėti ar pašalinti agentus iš gautų laiškų aplanko",
      "AGENT_ASSIGNMENT": "Pokalbio paskirstymas",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Atnaujinkite pokalbio priskirstymo nustatymus",
      "UPDATE": "Atnaujinti",
      "ENABLE_EMAIL_COLLECT_BOX": "Leisti el. pašto surinkimo dėžutę",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Naujame pokalbyje leiskite arba drauskite el. pašto surinkimo dėžutę",
      "AUTO_ASSIGNMENT": "Įjunkti automatinį priskyrimą",
      "ENABLE_CSAT": "Leisti CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Leisti CSAT kiekvienam pranešimui",
      "SENDER_NAME_SECTION": "Leisti agento vardą el. pašte",
      "ENABLE_CSAT_SUB_TEXT": "Leisti/neleisti CSAT (klientų pasitenkinimo) apklausą, kai baigsite pokalbį",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Leisti/neleisti CSAT (klientų pasitenkinimo) apklausos parinktį kiekvienam agentų išsiųstam pranešimui",
      "SENDER_NAME_SECTION_TEXT": "Įjungti/išjungti agento vardo rodymą el. pašte, jei išjungta, bus rodomas įmonės pavadinimas",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Leisti pokalbio tęstinumą el. paštu",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Jei kontaktinis el. pašto adresas yra pasiekiamas, pokalbiai bus tęsiami el. paštu.",
      "RESPOND_FROM_EMAIL": "Atsakyti iš el. pašto",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "El. laiškai klientui — tiek atsakymai, tiek pokalbio įrašai — siunčiami naudojant pasirinkto el. pašto gautų laiškų aplanko SMTP nustatymus, iš pasirinkto adreso (paties aplanko adreso arba vieno iš jo aliasų), o kliento atsakymai grįžta per jo IMAP adresą.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Pokalbio įrašai siunčiami naudojant pasirinkto el. pašto gautų laiškų aplanko SMTP nustatymus, iš pasirinkto adreso (paties aplanko adreso arba vieno iš jo aliasų), o atsakymai grįžta per jo IMAP adresą.",
      "SHOW_WELCOME_SCREEN": "Rodyti pasveikinimo ekraną",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Atidarius valdiklį, rodyti pasveikinimo ekraną. Jei išjungta, valdiklis iš karto pereis į pokalbio rodinį.",
      "AUTO_CLOSE_PENDING": "Automatiškai išspręsti AI pokalbius po (valandų)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automatiškai išspręsti AI pokalbius po X valandų neaktyvumo.",
      "LOCK_TO_SINGLE_CONVERSATION": "Laikykitės vieno pokalbio",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Leisti arba neleisti kelis pokalbius tam pačiam kontaktui šiame gautų laiškų aplanke",
      "INBOX_UPDATE_TITLE": "Gautų Laiškų Aplanko Nustatymai",
      "INBOX_UPDATE_SUB_TEXT": "Atnaujinkite gautų laiškų aplanko nustatymus",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Įjunkite arba išjunkite automatinį naujų pokalbių priskyrimą agentams, pridėtiems prie šio gautų laiškų aplanko.",
      "HMAC_VERIFICATION": "Vartotojo Tapatybės Patvirtinimas",
      "HMAC_DESCRIPTION": "Naudodami šį raktą galite sugeneruoti slaptą prieigos raktą, kuris gali būti naudojamas jūsų vartotojų tapatybei patikrinti.",
      "HMAC_ROTATE": {
        "BUTTON": "Pakeisti raktą",
        "TITLE": "Pakeisti slaptą raktą?",
        "WARNING": "Dabartinis raktas panaikinamas tą pačią akimirką, kai jį pakeičiate.",
        "WARNING_DETAIL": "Nėra pereinamojo laikotarpio, ir rakto atkurti negalima.",
        "IMPACT": "Jūsų serveriai vartotojus turi pasirašyti nauju raktu. Vartotojai, pasirašyti senuoju raktu, patikros nepraeina. Jei reikalingas vartotojo tapatybės patvirtinimas, jie negali pradėti pokalbio.",
        "CONFIRM": "Pakeisti raktą",
        "CANCEL": "Atšaukti",
        "SUCCESS": "Slaptas raktas sėkmingai pakeistas",
        "ERROR": "Nepavyko pakeisti slapto rakto, bandykite dar kartą"
      },
      "HMAC_LINK_TO_DOCS": "Detaliau skaityti čia.",
      "HMAC_MANDATORY_VERIFICATION": "Priverstinis Vartotojo Tapatybės Patvirtinimas",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Priverstinai pradėti naują pokalbį kiekvieną kartą įkėlus valdiklį",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Jei įjungta, atidarius valdiklį naujame skirtuke ar lange pradedamas naujas pokalbis.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Pamiršti kontaktą pradėjus naują pokalbį",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Jei išjungta, iš valdiklio pradėtas naujas pokalbis išsaugo ankstesnį kontaktą.",
      "INBOX_IDENTIFIER": "Gautų Laiškų Aplanko Identifikatorius",
      "INBOX_IDENTIFIER_SUB_TEXT": "Norėdami patvirtinti API klientų tapatybę, naudokite čia rodomą „inbox_identifier“ prieigos raktą.",
      "FORWARD_EMAIL_TITLE": "Persiųsti į el. paštą",
      "FORWARD_EMAIL_SUB_TEXT": "Pradėkite peradresuoti savo el. laiškus toliau nurodytu el. pašto adresu.",
      "EMAIL_FETCHING_ENABLED_TITLE": "El. pašto sinchronizavimas",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Įjungti automatinį šio gautų laiškų aplanko gaunamų el. laiškų sinchronizavimą ir atsisiuntimą",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Pasirinktinis el. pašto domenas",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Įjunkite, kad siunčiamiems laiškams būtų naudojamas pasirinktinis el. pašto domenas",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Daugiau galite paskaityti čia.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook komentarai",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Leisti pranešimus pokalbiui pasibaigus",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Leiskite galutiniams vartotojams siųsti pranešimus net pokalbiui pasibaigus.",
      "WIDGET_STATUS_LABEL": "Valdiklio būsena",
      "WIDGET_STATUS_ENABLED": "Įjungta",
      "WIDGET_STATUS_BUSINESS_HOURS": "Įjungta darbo valandomis",
      "WIDGET_STATUS_DISABLED": "Išjungta",
      "WIDGET_STATUS_HELP_TEXT": "Valdykite, kada valdiklis rodomas jūsų svetainės lankytojams",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Atnaujinkite išankstinio pokalbio internetu formos nustatymus",
      "EXPLICIT_CSAT_LOCALE": "CSAT apklausos ir el. pašto kalba",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Pasirinkite kalbą visiems kliento el. laiškams, įskaitant CSAT apklausas, pokalbio įrašus ir el. pašto pranešimus",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Paveldėti iš paskyros",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp ryšys",
        "SUBTITLE": "Kaip ši dėžutė prijungta prie WhatsApp.",
        "PROVIDER": "Teikėjas",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Prijungta per Meta įterptąją registraciją",
        "STATUS": "Būsena",
        "CONNECTED": "Prijungta",
        "RECONNECT_HINT": "Spustelėkite Prijungti iš naujo pranešime viršuje.",
        "PHONE_NUMBER": "Telefono numeris",
        "BUSINESS_ACCOUNT": "WhatsApp Business paskyros ID",
        "OPEN_MANAGER": "Atidaryti WhatsApp Manager",
        "PHONE_NUMBER_ID": "Telefono numerio ID",
        "TEMPLATES": "Pranešimų šablonai",
        "TEMPLATES_COUNT": "Patvirtinta {approved} iš {total}",
        "TEMPLATES_SYNCED": "Paskutinį kartą sinchronizuota {date}",
        "TEMPLATES_NOT_SYNCED": "Dar nesinchronizuota",
        "MANAGE_TEMPLATES": "Tvarkyti šablonus"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Palaikymo centras",
      "PLACEHOLDER": "Pasirinkti Pagalbos Centrą",
      "SELECT_PLACEHOLDER": "Pasirinkti Pagalbos Centrą",
      "REMOVE": "Pašalinti Pagalbos Centrą",
      "SUB_TEXT": "Pridėkite pagalbos centrą prie gautų laiškų aplanko"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Automatinio priskyrimo limitas",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Įveskite reikšmę, didesnę nei 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Apribokite maksimalų pokalbių skaičių iš šio gautų laiškų aplanko, kuriuos galima automatiškai priskirti agentui"
    },
    "SLA": {
      "TITLE": "SLA politikos",
      "SUB_TEXT": "Sukonfigūruokite SLA atsakymo ir išsprendimo laikus kiekvienam pokalbio prioriteto lygiui.",
      "LOADING": "Įkeliamos SLA politikos...",
      "FIELDS": {
        "ACTIVE": "Aktyvus",
        "TICKET_PRIORITY": "Bilieto prioritetas",
        "FIRST_RESPONSE_TIME": "Pirmojo atsakymo laikas",
        "EVERY_RESPONSE_TIME": "Kiekvieno atsakymo laikas",
        "RESOLUTION_TIME": "Sprendimo laikas",
        "PLACEHOLDER": "pvz. 1 val. 30 min."
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA politikos sėkmingai atnaujintos.",
        "ERROR_MESSAGE": "Nepavyko atnaujinti SLA politikų. Bandykite dar kartą."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatinis prioritetas",
      "SUB_TEXT": "Sukonfigūruokite automatinį prioriteto priskyrimą pagal pokalbio turinį.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Pranešimas apie apmokestinimą",
        "MESSAGE": "Už kiekvieną prioriteto įvertinimą bus taikomas mokestis. Kainodaros informacijos ieškokite savo plano informacijoje."
      },
      "MODE": {
        "OFF": "Išjungta",
        "ALL_MESSAGES": "Įjungta visiems gaunamiems pranešimams",
        "FIRST_MESSAGE": "Įjungta tik pirmam gaunamam pranešimui"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Prioriteto lygių konfigūracija",
        "SUB_TEXT": "Sukonfigūruokite, kurie prioriteto lygiai turi būti įjungti, ir jų aprašymus. Pateikite aiškius kriterijus, pagal kuriuos AI nustatytų, kada šis prioritetas turi būti priskirtas."
      },
      "DESCRIPTION_LABEL": "Aprašymas",
      "DESCRIPTION_PLACEHOLDER": "Aprašykite pokalbius, kurie turi būti pažymėti {priority} prioritetu",
      "SET_AS_DEFAULT": "Nustatyti kaip numatytąjį prioritetą",
      "MULTIPLE_DEFAULTS_WARNING": "Tik vienas prioriteto lygis gali būti nustatytas kaip numatytasis. Panaikinkite kitų numatytųjų žymėjimą."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatinis žymėjimas",
      "SUB_TEXT": "Sukonfigūruokite automatinį etikečių priskyrimą pagal pokalbio turinį.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Pranešimas apie apmokestinimą",
        "MESSAGE": "Už kiekvieną žymėjimo įvertinimą bus taikomas mokestis. Kainodaros informacijos ieškokite savo plano informacijoje."
      },
      "MODE": {
        "OFF": "Išjungta",
        "CONVERSATION_OPEN": "Atidarius pokalbį",
        "CONVERSATION_CLOSE": "Uždarius pokalbį",
        "ALL_MESSAGES": "Kiekvieną pranešimą - nepriklausomai nuo būsenos",
        "FIRST_MESSAGE": "Pirmą pranešimą - nepriklausomai nuo būsenos"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Etikečių konfigūracija",
        "SUB_TEXT": "Sukonfigūruokite, kurios etiketės turi būti prieinamos automatiniam priskyrimui, ir jų aprašymus. Pateikite aiškius kriterijus, pagal kuriuos AI nustatytų, kada ši etiketė turi būti taikoma."
      },
      "DESCRIPTION_LABEL": "Aprašymas",
      "DESCRIPTION_PLACEHOLDER": "Aprašykite pokalbius, kurie turi būti pažymėti etikete {label}. Jei paliksite tuščią, bus naudojamas etiketės aprašymas.",
      "NO_LABELS_MESSAGE": "Etikečių nerasta. Pirmiausia sukurkite etiketes, kad įjungtumėte automatinį žymėjimą.",
      "CREATE_LABELS_LINK": "Sukurti etiketes"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Pakartotinai autorizuoti",
      "SUBTITLE": "Jūsų ryšys su Facebook nutrūko. Jei norite toliau nauditis paslaugomis, iš naujo prisijunkite prie Facebook puslapio",
      "MESSAGE_SUCCESS": "Pakartotinis prisijungimas sėkmingas",
      "MESSAGE_ERROR": "Įvyko klaida, prašau pabandykite dar kartą"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Išankstiniai poklabio ruošiniai leidžia surinkti informaciją apie vartotoją, prieš jam pradedant pokalbį su jumis.",
      "SET_FIELDS": "Pokalbio internetu formos laukai",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Laukai",
        "LABEL": "Etiketė",
        "PLACE_HOLDER": "Rezervuota vieta",
        "KEY": "Raktas",
        "TYPE": "Tipas",
        "REQUIRED": "Reikalingas"
      },
      "ENABLE": {
        "LABEL": "Leisti poklabio internetu formą",
        "OPTIONS": {
          "ENABLED": "Taip",
          "DISABLED": "Ne"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pokalbio internetu pranešimas",
        "PLACEHOLDER": "Šis pranešimas bus matomas vartotojams kartu su forma"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Prieš pradėdami pokalbį lankytojai turėtų nurodyti savo vardą ir el. pašto adresą"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Nustatykite savo pasiekiamumą",
      "SUBTITLE": "Nustatykite savo pasiekiamumą tiesioginio pokalbio valdiklyje",
      "WEEKLY_TITLE": "Nustatykite savaitės darbo valandas",
      "TIMEZONE_LABEL": "Pasirinkti laiko zoną",
      "UPDATE": "Atnaujinti darbo laiko nustatymus",
      "TOGGLE_AVAILABILITY": "Leisti verslo pasiekiamumą šiam gautų laiškų aplankui",
      "UNAVAILABLE_MESSAGE_LABEL": "Pranešimas lankytojams apie nepasiekiamumą",
      "TOGGLE_HELP": "Nustačius darbo laiką, bus rodomos darbo valandos chato valdiklyje, net jei visi agentai neprisijungę. Ne darbo valandomis lankytojai gali būti įspėti pranešimu ir išankstinio pokalbio forma.",
      "DAY": {
        "ENABLE": "Įgalinti pasiekiamumą šiai dienai",
        "UNAVAILABLE": "Nepasiekiamas",
        "HOURS": "valandos",
        "VALIDATION_ERROR": "Pradžios laikas turi būti prieš pabaigos laiką.",
        "CHOOSE": "Pasirinkti"
      },
      "ALL_DAY": "Visą dieną",
      "SAVE_TO_ALL": "Išsaugoti visuose gautų laiškų aplankuose",
      "SAVE_TO_ALL_TITLE": "Kopijuoti darbo valandas",
      "SAVE_TO_ALL_CONFIRM": "Šios formos nustatymai (pasiekiamumo perjungiklis, nebuvimo darbe pranešimas, laiko zona ir darbo valandos) bus nukopijuoti į visus kitus gautų laiškų aplankus, išskyrus el. pašto ir telefono aplankus. Ar tikrai norite tęsti?",
      "SAVE_TO_ALL_CANCEL": "Atšaukti",
      "SAVE_TO_ALL_YES": "Taip, kopijuoti visiems",
      "SAVE_TO_ALL_SUCCESS": "Darbo valandos sėkmingai nukopijuotos į visus kitus gautų laiškų aplankus",
      "SAVE_TO_ALL_ERROR": "Nepavyko nukopijuoti darbo valandų į kitus gautų laiškų aplankus"
    },
    "PHONE": {
      "TITLE": "Telefono nustatymai",
      "SUBTITLE": "Sukonfigūruokite, kokie skambučiai bus rodomi šiame gautų laiškų aplanke.",
      "UPDATE": "Išsaugoti nustatymus",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefono nustatymai atnaujinti"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefono numeriai",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Nustatykite savo IMAP informaciją",
      "NOTE_TEXT": "Norėdami įjungti SMTP, sukonfigūruokite IMAP.",
      "UPDATE": "Atnaujinti IMAP nustatymus",
      "TOGGLE_AVAILABILITY": "Leisti IMAP konfigūraciją šiam gautų laiškų aplankui",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP nustatymai atnaujinti sėkmingai",
        "ERROR_MESSAGE": "Nepavyko atnaujinti IMAP nustatymų"
      },
      "ADDRESS": {
        "LABEL": "Adresas",
        "PLACE_HOLDER": "Adresas (pvz.: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Portas",
        "PLACE_HOLDER": "Portas"
      },
      "LOGIN": {
        "LABEL": "Prisijungti",
        "PLACE_HOLDER": "Prisijungti"
      },
      "PASSWORD": {
        "LABEL": "Slaptažodis",
        "PLACE_HOLDER": "Slaptažodis"
      },
      "ENABLE_SSL": "Leisti SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Iš naujo autorizuokite savo MICROSOFT paskyrą"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Nustatykite savo SMTP informaciją",
      "UPDATE": "Atnaujinti SMTP nustatymus",
      "TOGGLE_AVAILABILITY": "Leisti SMTP konfigūraciją šiam gautų laiškų aplankui",
      "TOGGLE_HELP": "Įjungus SMTP, vartotojas galės siųsti el. laiškus",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP nustatymai atnaujinti sėkmingai",
        "ERROR_MESSAGE": "Nepavyko atnaujinti SMTP nustatymų"
      },
      "ADDRESS": {
        "LABEL": "Adresas",
        "PLACE_HOLDER": "Adresas (pvz.: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Portas",
        "PLACE_HOLDER": "Portas"
      },
      "LOGIN": {
        "LABEL": "Prisijungti",
        "PLACE_HOLDER": "Prisijungti"
      },
      "PASSWORD": {
        "LABEL": "Slaptažodis",
        "PLACE_HOLDER": "Slaptažodis"
      },
      "DOMAIN": {
        "LABEL": "Domenas",
        "PLACE_HOLDER": "Domenas"
      },
      "ENCRYPTION": "Šifravimas",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Patikros Režimas",
      "AUTH_MECHANISM": "Autentifikacija"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "El. laiškų pristatymas (DNS)",
      "SUB_TITLE": "Kiekvieną darbo dieną tikriname domeno {domain} SPF, DKIM, DMARC ir MX įrašus. Kai dėl kažko gaunantys serveriai atmeta Jūsų atsakymus arba laiko juos šlamštu, administratoriai gauna el. laišką su sprendimu.",
      "RUN": "Patikrinti",
      "RUN_SUCCESS": "DNS patikra baigta",
      "RUN_ERROR": "Nepavyko atlikti DNS patikros, bandykite dar kartą",
      "NOT_CHECKED": "Dar netikrinta.",
      "CHECKED_AT": "Paskutinį kartą tikrinta {time}.",
      "DNS_UNAVAILABLE": "Paskutinės patikros metu domeno vardų serveriai neatsakė. Toliau pateiktas ankstesnės patikros rezultatas.",
      "SENDER": {
        "SMTP": "Atsakymai siunčiami per {host}.",
        "PLATFORM": "Atsakymai siunčiami per mūsų pašto serverius."
      },
      "STATUS": {
        "OK": "Visi įrašai tvarkingi",
        "WARNING": "Kai kuriuos įrašus galima pagerinti",
        "ERROR": "Atsakymai gali nepasiekti gavėjų",
        "UNKNOWN": "Nežinoma"
      },
      "SEVERITY": {
        "ERROR": "Problema",
        "WARNING": "Įspėjimas"
      },
      "FIX": "Problemą išspręsite šiuo DNS įrašu:",
      "RECORD_TYPE": "Tipas",
      "RECORD_HOST": "Pavadinimas",
      "RECORD_VALUE": "Reikšmė",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Trūksta SPF įrašo",
          "DESCRIPTION": "Domenas nenurodo, kurie serveriai gali siųsti jo el. laiškus. Todėl daugelis pašto serverių Jūsų atsakymus laiko šlamštu. Pridėkite SPF įrašą, kuris leistų {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domenas turi {count} SPF įrašų",
          "DESCRIPTION": "Domenas gali turėti tik vieną SPF įrašą. Jei jų daugiau, gaunantys serveriai SPF ignoruoja ir dažnai atmeta laiškus. Sujunkite juos į vieną įrašą."
        },
        "spf_not_authorized": {
          "TITLE": "SPF neleidžia serverio, kuris siunčia Jūsų atsakymus",
          "DESCRIPTION": "Jūsų atsakymai siunčiami per {sender}, bet domeno SPF įraše jo nėra. Dabartinis įrašas: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF įrašui reikia per daug DNS užklausų",
          "DESCRIPTION": "Gaunantys serveriai nustoja tikrinti SPF po {limit} DNS užklausų, o {sender}, per kurį siunčiami Jūsų atsakymai, pasiekiamas tik po {lookups}. Jūsų atsakymai nepraeina SPF patikros. Perkelkite {sender} į įrašo pradžią ir pašalinkite include įrašus, kurių domenas nebenaudoja."
        },
        "spf_lookups_others": {
          "TITLE": "Kai kurie SPF įrašo siuntėjai viršija užklausų ribą",
          "DESCRIPTION": "SPF įrašui reikia {lookups} DNS užklausų, o gaunantys serveriai sustoja po {limit}. Jūsų atsakymai suderinami laiku ir praeina patikrą, bet šių siuntėjų laiškai SPF patikros nepraeina: {senders}. Pašalinkite include įrašus, kurių domenas nebenaudoja."
        },
        "spf_malformed": {
          "TITLE": "SPF įrašas sugadintas",
          "DESCRIPTION": "Gaunantys serveriai negali perskaityti domeno SPF įrašo, todėl jis neapsaugo Jūsų atsakymų. Problema šiame fragmente: {terms}. Pakeiskite įrašą ištaisytu."
        },
        "dkim_missing": {
          "TITLE": "DKIM parašas nenustatytas",
          "DESCRIPTION": "Nerasta DKIM rakto adresu {selectors}. Be jo Jūsų atsakymai nepasirašomi ir dažniau patenka į šlamštą. Įjunkite DKIM pasirašymą savo domenui pas el. pašto paslaugų teikėją."
        },
        "dmarc_missing": {
          "TITLE": "Trūksta DMARC įrašo",
          "DESCRIPTION": "Dideli pašto paslaugų teikėjai, tokie kaip Gmail ir Microsoft, tikisi DMARC įrašo. Be jo Jūsų atsakymai dažniau patenka į šlamštą."
        },
        "dmarc_fails": {
          "TITLE": "DMARC nurodo gavėjams atmesti Jūsų atsakymus",
          "DESCRIPTION": "Domeno DMARC politika yra „{policy}“, o Jūsų atsakymai nepraeina nei SPF, nei DKIM patikros, todėl gavėjai juos atmeta arba perkelia į šlamštą. Sutvarkykite pirmiau minėtus SPF ir DKIM."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokuoja atsakymus, siunčiamus per mūsų pašto serverius",
          "DESCRIPTION": "Ši pašto dėžutė siunčia atsakymus per mūsų pašto serverius, bet domeno DMARC politika yra „{policy}“, todėl gavėjai juos atmeta arba perkelia į šlamštą. Šiai dėžutei nustatykite savo pašto serverio SMTP."
        },
        "mx_missing": {
          "TITLE": "Domenas neturi MX įrašo",
          "DESCRIPTION": "Be MX įrašo niekas negali siųsti el. laiškų į šį domeną, todėl klientai negali atsakyti į Jūsų laiškus."
        }
      }
    },
    "NOTE": "Pastaba: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Svetainės Avataras",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avataras ištrintas sėkmingai",
              "ERROR_MESSAGE": "Įvyko klaida, prašau pabandykite dar kartą"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Intenetinio Puslapio pavadinimas",
          "PLACE_HOLDER": "Įveskite savo internetinio puslapio pavadinimą (pvz.: Acme Inc)",
          "ERROR": "Prašome įrašyti teisingą internetinės svetainės pavadinimą"
        },
        "WELCOME_HEADING": {
          "LABEL": "Pasisveikinimo antraštė",
          "PLACE_HOLDER": "Sveiki!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Pasisveikinimo tekstas",
          "PLACE_HOLDER": "Su mumis susisiekti yra paprasta. Klauskite mūsų bet ko arba pasidalykite savo atsiliepimais."
        },
        "REPLY_TIME": {
          "LABEL": "Atsakymo laikas",
          "IN_A_FEW_MINUTES": "Per kelias minutes",
          "IN_A_FEW_HOURS": "Per kelias minutes",
          "IN_A_DAY": "Per dieną"
        },
        "WIDGET_COLOR_LABEL": "Valdiklio Spalva",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Padėtis",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maksimalus neperskaitytų žinučių aukštis (px)",
          "PLACE_HOLDER": "Be apribojimų",
          "HELP_TEXT": "Apribokite neperskaitytų žinučių iškylančiojo lango maksimalų aukštį pikseliais. Palikite tuščią numatytajai elgsenai (be apribojimų)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Tipas",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Pabendraukite su mumis",
          "LABEL": "Widget Bubble Paleidimo programos pavadinimas",
          "PLACE_HOLDER": "Pabendraukite su mumis"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Atnaujinti valdiklio nustatymus",
          "API": {
            "SUCCESS_MESSAGE": "Vldiklio nustatymai atnaujinti sėkmingai",
            "ERROR_MESSAGE": "Nepavyko atnaujinti valdiklio nustatymų"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Peržiūrėti",
          "SCRIPT": "Scenarijus"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Kairė",
          "RIGHT": "Dešinė"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standartas",
          "EXPANDED_BUBBLE": "Išplėstas burbulas"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Pagal nutylėjimą",
        "CHAT": "Pokalbis internetu"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Paprastai atsako per kelias minutes",
        "IN_A_FEW_HOURS": "Paprastai atsako per kelias valandas",
        "IN_A_DAY": "Paprastai atsako per dieną"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Pradėti Pokalbį",
        "CHAT_INPUT_PLACEHOLDER": "Parašykite pranešimą"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Mes prisijungę",
          "OFFLINE": "Šiuo metu esame atsijungę"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Sveiki"
      },
      "BRANDING_TEXT": "Parengta pagal JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Kiti Tiekėjai"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Internetinis puslapis",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "El. paštas",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanalas",
      "PHONE": "SIP telefonas",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
